import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { DeliveryCmsComponents } from '@core/const';
import { YandexMapModule } from '@sdvor/yandex-maps/ui';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { AddressSuggestionsSelectModule } from '../address-suggestions-select';
import { DeliveryMapComponent } from './delivery-map.component';

@NgModule({
  declarations: [DeliveryMapComponent],
  imports: [
    AsyncPipe,
    NgIf,
    YandexMapModule,
    AddressSuggestionsSelectModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [DeliveryCmsComponents.SdCMSDeliveryMapComponent]: { component: DeliveryMapComponent },
      },
    }),
  ],
})
export class DeliveryMapModule {}
